import frontendLogger from "../utils/frontendLogger.js";
import useAuthUser from "../hooks/useAuthUser.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/App.css";
import "./css/MainPage.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { API_BASE_URL } from "../app_config.js";

const getAuthToken = () => localStorage.getItem("token");

export default function DeleteTastings() {
  const { username, role, loading: authLoading } = useAuthUser();
  const navigate = useNavigate();
  const [tastings, setTastings] = useState([]);
  const [selectedTastingId, setSelectedTastingId] = useState("");
  const [selectedTastingMottoDate, setSelectedTastingMottoDate] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Redirect wenn nicht Admin
  useEffect(() => {
    if (!authLoading && role !== "admin") {
      navigate("/main");
    }
  }, [role, navigate, authLoading]);

  // Tastings laden
  useEffect(() => {
    const fetchTastings = async () => {
      try {
        const token = getAuthToken();
        const response = await fetch(`${API_BASE_URL}/api/tastingData`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error("Fehler beim Laden der Tastings");

        const data = await response.json();
        frontendLogger.info("Fetched tastings:", data);

        setTastings(data);
      } catch (error) {
        frontendLogger.error("Error fetching tastings:", error);
        setMessage("Fehler beim Laden der Tastings");
      }
    };

    fetchTastings();
  }, []);

  const handleTastingSelect = (e) => {
    const id = e.target.value;
    setSelectedTastingId(id);

    if (id) {
      const selected = tastings.find((t) => t.id === parseInt(id));
      if (selected) {
        const dateStr = selected.tasting_date
          ? new Date(selected.tasting_date).toLocaleDateString("de-DE")
          : "-";
        setSelectedTastingMottoDate(
          `${selected.motto} (${dateStr}) - ${selected.place || "Kein Ort"}`,
        );
      }
    } else {
      setSelectedTastingMottoDate("");
    }
  };

  const handleDeleteClick = () => {
    if (!selectedTastingId) {
      setMessage("Bitte wähle ein Tasting aus");
      return;
    }
    setShowConfirmation(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    setShowConfirmation(false);

    try {
      const token = getAuthToken();
      const response = await fetch(
        `${API_BASE_URL}/api/tastingData/${selectedTastingId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (!response.ok) {
        throw new Error("Fehler beim Löschen des Tastings");
      }

      const data = await response.json();
      frontendLogger.info("Tasting deleted:", data);

      setMessage(`✓ Das Tasting wurde vollständig gelöscht`);

      // Aktualisiere die Liste
      setTastings(tastings.filter((t) => t.id !== parseInt(selectedTastingId)));
      setSelectedTastingId("");
      setSelectedTastingMottoDate("");
    } catch (error) {
      frontendLogger.error("Error deleting tasting:", error);
      setMessage("Fehler beim Löschen des Tastings");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const handleBack = () => {
    navigate("/main");
  };

  return (
    <div className="page-layout">
      <div className="menu-container">
        <div className="title-box">
          <p>Willkommen bei DRAM</p>
        </div>
        <div className="menu-box">
          <h1>{username}</h1>
        </div>

        <nav className="nav">
          <button className="nav-button" onClick={handleBack}>
            Zurück
          </button>
        </nav>

        <img
          src={require("../assets/logo.png")}
          alt="Versionsinformationen anzeigen"
          className="whisky-image"
          role="button"
          tabIndex={0}
        />
      </div>

      <div className="content-container">
        <div className="search-form-group">
          <form
            id="deleteForm"
            onSubmit={(e) => {
              e.preventDefault();
              handleDeleteClick();
            }}
          >
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              Tasting löschen
            </h2>

            <label htmlFor="tasting-select">
              Wähle ein Tasting zum Löschen:
            </label>
            <select
              id="tasting-select"
              value={selectedTastingId}
              onChange={handleTastingSelect}
              style={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #c69c6d",
                fontSize: "14px",
              }}
            >
              <option value="">-- Tasting auswählen --</option>
              {tastings.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.motto} (
                  {t.tasting_date
                    ? new Date(t.tasting_date).toLocaleDateString("de-DE")
                    : "-"}
                  )
                </option>
              ))}
            </select>

            {message && (
              <div
                style={{
                  padding: "12px",
                  backgroundColor:
                    message.startsWith("✓") || message.startsWith("Das Tasting")
                      ? "#e8f5e9"
                      : "#ffebee",
                  color:
                    message.startsWith("✓") || message.startsWith("Das Tasting")
                      ? "#2e7d32"
                      : "#c62828",
                  borderRadius: "5px",
                  marginTop: "10px",
                  fontSize: "14px",
                  textAlign: "center",
                }}
              >
                {message}
              </div>
            )}

            <button
              type="submit"
              style={{
                padding: "12px 20px",
                background: "linear-gradient(135deg, #8b5e3c 0%, #5c3a21 100%)",
                border: "1px solid #c69c6d",
                borderRadius: "5px",
                color: "#f5e6d3",
                fontWeight: "600",
                cursor: selectedTastingId ? "pointer" : "not-allowed",
                fontSize: "14px",
                opacity: selectedTastingId ? 1 : 0.5,
                transition: "transform 0.15s ease, box-shadow 0.15s ease",
              }}
              disabled={!selectedTastingId || loading}
              onMouseEnter={(e) => {
                if (selectedTastingId) {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 6px 15px rgba(60, 40, 20, 0.25)";
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              {loading ? "Wird gelöscht..." : "Löschen"}
            </button>
          </form>
        </div>
      </div>

      {showConfirmation && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Tasting wirklich löschen?</h2>
            <p style={{ marginBottom: "20px" }}>
              Bist du sicher, dass du folgendes Tasting löschen möchtest?
              <br />
              <strong>"{selectedTastingMottoDate}"</strong>
            </p>
            <p
              style={{
                fontSize: "0.9em",
                color: "#c62828",
                marginBottom: "20px",
              }}
            >
              <strong>Warnung:</strong> Diese Aktion kann nicht rückgängig
              gemacht werden. Alle zugehörigen Daten werden gelöscht.
            </p>

            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              <button
                style={{
                  padding: "10px 20px",
                  background: "#ccc",
                  border: "1px solid #999",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                  transition: "background 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#bbb")}
                onMouseLeave={(e) => (e.target.style.background = "#ccc")}
                onClick={handleCancel}
              >
                Nein, abbrechen
              </button>
              <button
                style={{
                  padding: "10px 20px",
                  background:
                    "linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)",
                  color: "#fff",
                  border: "1px solid #b71c1c",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 6px 15px rgba(0, 0, 0, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
                onClick={handleConfirmDelete}
                disabled={loading}
              >
                Ja, löschen
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
